2<!-- POSIZIONARE ALL'INTERNO DI UN DIV RELATIVE CON ALTEZZA FISSA-->
<template>
  <div id="ilDiv" tabindex="1" class="row h-100">
    <div class="carrello col-5 p-0">
      <Carrello></Carrello>
    </div>
    <div
      class="col-md-7 p-0 h-100"
      style="position:relative; display:flex; flex-direction:column; height:100%; min-height:100%;"
    >
      <div class="container">
        <div class="row barra_tab">
          <div
            @click="tab_attivo = 'riparazioni'"
            :class="{'tab-selezionato' :tab_attivo === 'riparazioni' }"
            class="col-4 tab d-flex align-items-center"
          >
            <div class="mx-auto">Riparazioni</div>
          </div>
          <div
            @click="tab_attivo = 'accessori'"
            :class="{'tab-selezionato' :tab_attivo === 'accessori' }"
            class="col-4 tab d-flex align-items-center"
          >
            <div class="mx-auto">Accessori</div>
          </div>
          <div
            @click="tab_attivo =  'altro'"
            :class="{'tab-selezionato' :tab_attivo === 'altro' }"
            class="col-4 tab d-flex align-items-center"
          >
            <div class="mx-auto">Altro</div>
          </div>
        </div>
      </div>
      <div v-if="tab_attivo === 'riparazioni'" class="col-12" style=" flex:1; overflow:hidden;">
        <div
          class="h-100 w-100"
          style="position:relative; display:flex; flex-direction:column; min-height:100%;"
        >
          <div class="w-100 p-3 suggerimento d-flex align-items-center justify-content-center">
            <div class="w-100 h-100">
              <DeviceList
                v-on:newDevice="newDevice($event)"
                v-on:removeDevice="removeDevice($event)"
                v-on:setSelectedDevice="setSelectedDevice($event)"
                v-bind:riparazioni="cart"
                :selectedDevice="selectedDevice"
              ></DeviceList>
            </div>
          </div>
          <div
            style="flex:1; position:relative; display:block; padding-top:0px !important; overflow:hidden;"
          >
            <selettoreNew
              v-on:itemClicked="itemClicked($event)"
              :items="items"
              id="selettore"
              v-bind:selettore="selettore"
            ></selettoreNew>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div v-if="tab_attivo === 'accessori' && tabStato.accessori" class></div>
      </transition>
      <div v-if="tab_attivo === 'altro'" class="p-4">
        <h3>TAB ALTRO</h3>
      </div>
    </div>
    <!-- INFO DISPOSITIVO -->
    <infoDispositivo v-if="infoDispositivoIndex!==null" :device="cart[infoDispositivoIndex]"></infoDispositivo>
    <!-- MODAL INSERIMENTO PREZZO -->
    <inserimentoPrezzo
      v-on:closed="closePriceSetter"
      v-on:saved="priceHandler"
      :obj="setPriceOf"
      v-if="setPriceOf"
    ></inserimentoPrezzo>
    <!-- MASCHERA OPACA MODAL -->
    <transition name="fade">
      <div @click="mostra_modal(false,'')" v-if="showOverlay" class="overlay_mask"></div>
    </transition>
  </div>
</template>


<script>
var VueScrollTo = require("vue-scrollto");
let id_riparazione = 1;
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import Vue from "vue";
import elementoCarrello from "@/components/elementoCarrello";
import elementoCarrelloAcc from "@/components/elementoCarrelloAcc";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Carrello from "@/components/Carrello";
import DeviceList from "@/components/DeviceList";
import infoDispositivo from "@/components/infoDispositivo";
import inserimentoPrezzo from "@/components/inserimentoPrezzo";
import { Money } from "v-money";

const selettoreNew = () => import("@/components/selettoreNew");
Vue.component("selettoreNew", selettoreNew);

import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar,
    Carrello,
    DeviceList,
    infoDispositivo,
    inserimentoPrezzo
  },
  computed: {
    ...mapGetters({
      orderObj: "ordineStates/orderObj",
      orderState: "ordineStates/orderState",
      infoDispositivoIndex: "ordineStates/infoDispositivoIndex",
      selettore: "ordineStates/selettore",
      selectedDevice: "ordineStates/selectedDevice",
      cart: "ordineStates/cart",
      deviceList: "ordineStates/deviceList",
      deviceDettails: "ordineStates/deviceDettails",
      setPriceOf: "ordineStates/setPriceOf"
    }),
    items() {
      if (this.cart[this.selectedDevice] !== undefined)
        return this.cart[this.selectedDevice].ricambi;
      else return "";
    }
  },
  name: "Ordine",
  filters: {},
  data() {
    return {
      //DATI FITTIZI
      // riparazioni: [{"id":1,"id_dispositivo":"-LaCerCK4ArZsDzAwiw3","dispositivo":"iphone 6","percorso_ricambi":{"hook":"ricambi","id":"-LaCerCK4ArZsDzAwiw3","value":"iphone 6"},"immagine":"https://firebasestorage.googleapis.com/v0/b/jestionale-bfde2.appspot.com/o/Altro_mondo%2Fmodelli%2F-LaCerCK4ArZsDzAwiw3?alt=media","ricambi":[{"category":"-LaCerCK4ArZsDzAwiw3","costo":"0","fonte":"interno","id":"-LaX63caAfFSrKXeV-q4","img_name":"-LaX63caAfFSrKXeV-q4.ext","marca":"apple","modello":"iphone 6","parent":"ricambi","path":[{"tipologie":"-LKR3t7mPEYS8EA-EB7d"},{"marche":"-LaCdIRoK3hfWzI3om5K"},{"modelli":"-LaCerCK4ArZsDzAwiw3"},{"ricambi":"-LaX63caAfFSrKXeV-q4"}],"prezzo":"20","prezzo_vendita_ivato":"0","s1":"-LaCerCK4ArZsDzAwiw3/display nero","value":"display nero"},{"category":"-LaCerCK4ArZsDzAwiw3","costo":"0","fonte":"interno","id":"-LaX7vkLkISYrXwbESby","img_name":"-LaX7vkLkISYrXwbESby.ext","marca":"apple","modello":"iphone 6","parent":"ricambi","path":[{"tipologie":"-LKR3t7mPEYS8EA-EB7d"},{"marche":"-LaCdIRoK3hfWzI3om5K"},{"modelli":"-LaCerCK4ArZsDzAwiw3"},{"ricambi":"-LaX7vkLkISYrXwbESby"}],"prezzo":"10","prezzo_vendita_ivato":"0","s1":"-LaCerCK4ArZsDzAwiw3/altoparlante","value":"altoparlante"}],"parziale":0,"parziale_senza_sconto":"0.00","costo":"0.00","utile":"0.00","sconto":0,"scadenza":"","sblocco":"","note":""}],
      // dettagli_ord: {"stato":{"label":"in riparazione","colore":"#fbcf00"},"data":1560286109566,"scadenza":"","perc_iva":22,"utile":0,"totale":"","sconto_su_totale":0,"listino_attivo":""},
      //dati_cliente: { nominativo: "Brenno Vita", telefono: "3337273386" },
      selezionato: 0,
      //DATI ORDINE
      tab_attivo: "riparazioni",
      showOverlay: false,
      //COSTRUTTORE SELETTORE
      costruttore_selettore: {
        showAlwaysBreadCrumbs: false,
        mostra_prezzo: true, //LO USO IN ORDINE
        mostra_sconto: true, // LO USO IN LISTINO
        mantieniAggiuntivo: "", //LASCIA ACCESO IL TASTO AGGIUNTIVO (ES. MENTRE CREO REGOLA LISTINO) E INIBISCE CHE IL TASTO AGGIUNTIVO SI ATTIVI SU ALTRI QUADRATINI
        tastoAggiuntivo: false,
        mostra_pulsantini: true,
        scrolling_selettore: false,
        fine_scrolling_selettore: false,
        div: "div_selettore",
        wrapper: "wrap_selettore_ricambi",
        css: { height: "92px", marginTop: "8px", marginBottom: "17px" },
        //qui dentro puoi inserire codice puro css per stilizzare il selettore
        style: "",
        scroll: false,
        selezione: 0,
        div_scroll: "PerfectScroll",
        autofocus: false,
        focus: "0",
        termine_ricerca: "",
        timeout: 600,
        delay: "",
        tasto_back: false,
        tasto_nuova_rip: false,
        barra_ricerca: false,
        barra_breadCrumbs: true,
        stato_caricamento: "",
        classe_focus: "sele",
        tasto_aggiungi: false,
        altezza: "",
        step_selezionato: {},
        posizioneSelettore: "",
        arrayCarrello: [],
        positionToChildFolder: "",
        resetSelettore: "CambiaIlMioValoreConUnoAcasoEsiResettaIlSelettore"
      }
    };
  },
  methods: {
    closePriceSetter() {
      this.$store.dispatch("ordineStates/showPriceSetter", null);
    },
    priceHandler(obj) {
      this.$store.dispatch("ordineStates/addToCart", obj);
    },
    newDevice() {
      this.selettore.resetSelettore = { hook: "tipologie", value: "tipologie" };
    },
    itemClicked(obj) {
      //console.log("quadratino cliccato");
      //this.$store.commit("ordineStates/addToCart", obj);
      this.$store.dispatch("ordineStates/addToCartRequest", obj);
    },
    setSelectedDevice(payload) {
      console.log(payload.device.percorso_ricambi);
      this.$store.commit("ordineStates/setSelectedDevice", payload.index);
    },
    setRepairState(index, value) {
      var payload = {
        index: index,
        value: value
      };
      this.$store.commit("ordineStates/setRepairState", payload);
    },
    removeFromCart(payload) {
      console.log(index);
      this.$store.commit("ordineStates/removeFromCart", index);
    },
    removeDevice(index) {
      this.$store.dispatch("ordineStates/removeDevice", index);
    },
    setDeviceDettails(field, value) {
      var payload = {
        field: field,
        value: value
      };
      this.$store.commit("ordineStates/setDeviceDettails", payload);
    }
  },
  beforeDestroy() {
    //INIZIALIZZO I MODULI VUEX ORDINE E LISTINO
    this.$store.commit("ordineStates/resetOrder");
    this.$store.commit("listinoStates/initModule");
  },
  mounted() {
    //INIZIALIZZO IL SELETTORE PASSANDOGLI IL COSTRUTTORE VIA VUEX
    this.$store.commit(
      "ordineStates/initSelettore",
      this.costruttore_selettore
    );
    var self = this;
    var id = this.$route.query.id;
    var intent = this.$route.query.intent;
    if (id !== undefined) {
      this.$store
        .dispatch("ordineStates/getOrder", id)
        .then(response => {
          console.log("Ordine Caricato");
        })
        .catch(err => {
          console.log(err);
        });
    }
    if (intent === "new") this.$store.commit("ordineStates/setAsNew");
  },
  watch: {
    $route() {
      //SE CLICCO SU NUOVO ORDINE MENTRE UN ORDINE E' GIA' APERTO
      var id = this.$route.query.id;
      var intent = this.$route.query.intent;
      if (id !== undefined) {
        this.$store
          .dispatch("ordineStates/getOrder", id)
          .then(response => {
            console.log("Ordine Caricato");
          })
          .catch(err => {
            console.log(err);
          });
      }
      if (intent === "new") {
        this.$store.commit("ordineStates/resetOrder");
        this.$store.commit("ordineStates/setAsNew");
        this.$store.commit("listinoStates/initModule");
      }
    }
  }
};
</script>

<style scoped>
.carrello {
  height: 100%;
  -webkit-box-shadow: 2px 57px 3px -1px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 2px 57px 3px -1px rgba(0, 0, 0, 0.25);
  box-shadow: 2px 57px 3px -1px rgba(0, 0, 0, 0.25);
  font-size: 13px;
  position: relative;
}

.tab {
  background-color: #f1f1f1;
  border-right: solid white 2px;
  font-size: 13px;
  color: #494949;
  cursor: pointer;
}

.tab-selezionato {
  background-color: white !important;
}

.barra_tab {
  height: 38px;
  margin-top: 10px;
}

.suggerimento {
  height: 18vh;
}

.suggerimento > div {
  vertical-align: middle;
  margin: 0;
  font-size: 2vh;
  text-align: center;
  color: #979899;
  font-family: Arial;
}
</style>
